import { render, staticRenderFns } from "./SplitBtn.vue?vue&type=template&id=6a277e50"
import script from "./SplitBtn.vue?vue&type=script&lang=js"
export * from "./SplitBtn.vue?vue&type=script&lang=js"
import style0 from "./SplitBtn.vue?vue&type=style&index=0&id=6a277e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports